module.exports = __webpack_public_path__ + "static/media/nebulafix-logo.4cefe3ee.png";